import React, { useEffect, useState, useContext, useRef } from "react";

import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

import useSettings from "../../hooks/useSettings";
import { ToastContainer, toast } from 'react-toastify';
import { showSuccessToast } from '../../utils/toastHelper';
import { makeStyles, useTheme } from "@material-ui/core/styles";

import { Tab, Tabs, TextField } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import MaskInput from "../../components/MaskInput";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
  },
  sectionCard: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.palette.mode === "dark" 
      ? "0px 4px 20px rgba(0, 0, 0, 0.3)" 
      : "0px 4px 20px rgba(0, 0, 0, 0.06)",
    border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.06)"}`,
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: theme.palette.mode === "dark" 
        ? "0px 6px 24px rgba(0, 0, 0, 0.4)" 
        : "0px 6px 24px rgba(0, 0, 0, 0.1)",
    },
  },
  sectionTitle: {
    fontSize: "1.25rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },
  sectionDescription: {
    fontSize: "0.875rem",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
    lineHeight: 1.6,
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 240,
  },
  cardAvatar: {
    fontSize: "55px",
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.mode === "dark" 
      ? "rgba(255, 255, 255, 0.05)" 
      : "rgba(0, 0, 0, 0.02)",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  cardSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  formControl: {
    width: "100%",
    marginBottom: theme.spacing(2),
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.palette.mode === "dark" 
        ? "rgba(255, 255, 255, 0.05)" 
        : "#f8f9fa",
      borderRadius: 10,
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      "& fieldset": {
        borderColor: theme.palette.mode === "dark" 
          ? "rgba(255, 255, 255, 0.12)" 
          : "rgba(0, 0, 0, 0.12)",
        borderWidth: 1.5,
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      },
      "&:hover": {
        backgroundColor: theme.palette.mode === "dark" 
          ? "rgba(255, 255, 255, 0.08)" 
          : "#f0f2f5",
        "& fieldset": {
          borderColor: theme.palette.mode === "dark" 
            ? "rgba(255, 255, 255, 0.2)" 
            : "rgba(0, 0, 0, 0.25)",
          borderWidth: 2,
        },
      },
      "&.Mui-focused": {
        backgroundColor: theme.palette.mode === "dark" 
          ? "rgba(255, 255, 255, 0.1)" 
          : "#ffffff",
        "& fieldset": {
          borderColor: theme.palette.primary.main,
          borderWidth: 2,
          boxShadow: `0 0 0 3px ${theme.palette.mode === "dark" 
            ? "rgba(25, 118, 210, 0.2)" 
            : "rgba(25, 118, 210, 0.1)"}`,
        },
      },
    },
    "& .MuiInputLabel-root": {
      fontWeight: 500,
      fontSize: "0.875rem",
      color: theme.palette.text.secondary,
      transform: "translate(14px, 12px) scale(1)",
      "&.MuiInputLabel-shrink": {
        transform: "translate(14px, -6px) scale(0.75)",
        color: theme.palette.text.secondary,
      },
      "&.Mui-focused": {
        color: theme.palette.primary.main,
        fontWeight: 600,
        transform: "translate(14px, -6px) scale(0.75)",
      },
    },
    "& .MuiSelect-select": {
      padding: theme.spacing(1.5, 1.75),
      fontSize: "0.9375rem",
      fontWeight: 500,
      color: theme.palette.text.primary,
      "&:focus": {
        backgroundColor: "transparent",
      },
    },
    "& .MuiSelect-icon": {
      color: theme.palette.text.secondary,
      transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      fontSize: "1.5rem",
    },
    "&.Mui-focused .MuiSelect-icon": {
      color: theme.palette.primary.main,
      transform: "rotate(180deg)",
    },
  },
  // Estilos para o Menu (dropdown)
  selectMenu: {
    "& .MuiPaper-root": {
      borderRadius: 12,
      marginTop: theme.spacing(1),
      boxShadow: theme.palette.mode === "dark" 
        ? "0px 8px 24px rgba(0, 0, 0, 0.4)" 
        : "0px 8px 24px rgba(0, 0, 0, 0.12)",
      border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)"}`,
      backgroundColor: theme.palette.background.paper,
      "& .MuiMenuItem-root": {
        borderRadius: 8,
        margin: theme.spacing(0.5, 1),
        padding: theme.spacing(1.25, 1.75),
        fontSize: "0.9375rem",
        fontWeight: 500,
        minHeight: "auto",
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          backgroundColor: theme.palette.mode === "dark" 
            ? "rgba(25, 118, 210, 0.15)" 
            : "rgba(25, 118, 210, 0.08)",
          transform: "translateX(4px)",
        },
        "&.Mui-selected": {
          backgroundColor: theme.palette.mode === "dark" 
            ? "rgba(25, 118, 210, 0.25)" 
            : "rgba(25, 118, 210, 0.12)",
          color: theme.palette.primary.main,
          fontWeight: 600,
          "&:hover": {
            backgroundColor: theme.palette.mode === "dark" 
              ? "rgba(25, 118, 210, 0.3)" 
              : "rgba(25, 118, 210, 0.16)",
          },
        },
      },
    },
  },
  checkboxLabel: {
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
  helperText: {
    color: theme.palette.text.secondary,
    fontSize: "0.75rem",
    marginTop: theme.spacing(0.5),
  },
  tab: {
    backgroundColor: theme.palette.mode === 'light' 
      ? "rgba(0, 0, 0, 0.02)" 
      : "rgba(255, 255, 255, 0.05)",
    borderRadius: 4,
    width: "100%",
    "& .MuiTabs-flexContainer": {
      justifyContent: "center"
    }
  },
}));

export default function Options(props) {
  const { oldSettings, settings, scheduleTypeChanged, user } = props;

  const classes = useStyles();
  
  // Refs para guardar o último valor salvo de cada campo
  const lastSavedEfiClientid = useRef('');
  const lastSavedEfiClientsecret = useRef('');
  const lastSavedEfiChavepix = useRef('');
  const lastSavedmpaccesstoken = useRef('');
  const lastSavedstripeprivatekey = useRef('');
  const lastSavedasaastoken = useRef('');
  const lastSavedopenaitoken = useRef('');
  
  const [userRating, setUserRating] = useState("disabled");
  const [scheduleType, setScheduleType] = useState("disabled");
  const [chatBotType, setChatBotType] = useState("text");

  const [loadingUserRating, setLoadingUserRating] = useState(false);
  const [loadingScheduleType, setLoadingScheduleType] = useState(false);

  const [userCreation, setUserCreation] = useState("disabled");
  const [loadingUserCreation, setLoadingUserCreation] = useState(false);

  const [SendGreetingAccepted, setSendGreetingAccepted] = useState("enabled");
  const [loadingSendGreetingAccepted, setLoadingSendGreetingAccepted] = useState(false);

  const [UserRandom, setUserRandom] = useState("enabled");
  const [loadingUserRandom, setLoadingUserRandom] = useState(false);

  const [SettingsTransfTicket, setSettingsTransfTicket] = useState("enabled");
  const [loadingSettingsTransfTicket, setLoadingSettingsTransfTicket] = useState(false);

  const [AcceptCallWhatsapp, setAcceptCallWhatsapp] = useState("enabled");
  const [loadingAcceptCallWhatsapp, setLoadingAcceptCallWhatsapp] = useState(false);

  const [sendSignMessage, setSendSignMessage] = useState("enabled");
  const [loadingSendSignMessage, setLoadingSendSignMessage] = useState(false);

  const [sendGreetingMessageOneQueues, setSendGreetingMessageOneQueues] = useState("enabled");
  const [loadingSendGreetingMessageOneQueues, setLoadingSendGreetingMessageOneQueues] = useState(false);

  const [sendQueuePosition, setSendQueuePosition] = useState("enabled");
  const [loadingSendQueuePosition, setLoadingSendQueuePosition] = useState(false);

  // Queue Position Updates (notificações automáticas)
  const [enableQueuePositionUpdates, setEnableQueuePositionUpdates] = useState(false);
  const [loadingEnableQueuePositionUpdates, setLoadingEnableQueuePositionUpdates] = useState(false);

  const [queuePositionUpdateInterval, setQueuePositionUpdateInterval] = useState(5);
  const [loadingQueuePositionUpdateInterval, setLoadingQueuePositionUpdateInterval] = useState(false);

  const [queuePositionUpdateThreshold, setQueuePositionUpdateThreshold] = useState(3);
  const [loadingQueuePositionUpdateThreshold, setLoadingQueuePositionUpdateThreshold] = useState(false);

  const [queuePositionSpecialMessage, setQueuePositionSpecialMessage] = useState("");
  const [loadingQueuePositionSpecialMessage, setLoadingQueuePositionSpecialMessage] = useState(false);

  const [sendFarewellWaitingTicket, setSendFarewellWaitingTicket] = useState("enabled");
  const [loadingSendFarewellWaitingTicket, setLoadingSendFarewellWaitingTicket] = useState(false);

  const [acceptAudioMessageContact, setAcceptAudioMessageContact] = useState("enabled");
  const [loadingAcceptAudioMessageContact, setLoadingAcceptAudioMessageContact] = useState(false);

  //PAYMENT METHODS
  const [eficlientidType, setEfiClientidType] = useState('');
  const [loadingEfiClientidType, setLoadingEfiClientidType] = useState(false);

  const [eficlientsecretType, setEfiClientsecretType] = useState('');
  const [loadingEfiClientsecretType, setLoadingEfiClientsecretType] =
    useState(false);

  const [efichavepixType, setEfiChavepixType] = useState('');
  const [loadingEfiChavepixType, setLoadingEfiChavepixType] = useState(false);

  const [mpaccesstokenType, setmpaccesstokenType] = useState('');
  const [loadingmpaccesstokenType, setLoadingmpaccesstokenType] =
    useState(false);

  const [stripeprivatekeyType, setstripeprivatekeyType] = useState('');
  const [loadingstripeprivatekeyType, setLoadingstripeprivatekeyType] =
    useState(false);

  const [asaastokenType, setasaastokenType] = useState('');
  const [loadingasaastokenType, setLoadingasaastokenType] = useState(false);

  //OPENAI API KEY TRANSCRIÇÃO DE ÁUDIO
  const [openaitokenType, setopenaitokenType] = useState('');
  const [loadingopenaitokenType, setLoadingopenaitokenType] = useState(false);

  //LGPD
  const [enableLGPD, setEnableLGPD] = useState("disabled");
  const [loadingEnableLGPD, setLoadingEnableLGPD] = useState(false);

  const [lgpdMessage, setLGPDMessage] = useState("");
  const [loadinglgpdMessage, setLoadingLGPDMessage] = useState(false);

  const [lgpdLink, setLGPDLink] = useState("");
  const [loadingLGPDLink, setLoadingLGPDLink] = useState(false);

  const [lgpdDeleteMessage, setLGPDDeleteMessage] = useState("disabled");
  const [loadingLGPDDeleteMessage, setLoadingLGPDDeleteMessage] = useState(false);

  //LIMITAR DOWNLOAD
  // const [downloadLimit, setdownloadLimit] = useState("64");
  // const [loadingDownloadLimit, setLoadingdownloadLimit] = useState(false);

  const [lgpdConsent, setLGPDConsent] = useState("disabled");
  const [loadingLGPDConsent, setLoadingLGPDConsent] = useState(false);

  const [lgpdHideNumber, setLGPDHideNumber] = useState("disabled");
  const [loadingLGPDHideNumber, setLoadingLGPDHideNumber] = useState(false);

  // Tag obrigatoria
  const [requiredTag, setRequiredTag] = useState("enabled")
  const [loadingRequiredTag, setLoadingRequiredTag] = useState(false)

  // Fechar ticket ao transferir para outro setor
  const [closeTicketOnTransfer, setCloseTicketOnTransfer] = useState(false)
  const [loadingCloseTicketOnTransfer, setLoadingCloseTicketOnTransfer] = useState(false)

  // Status do ticket ao transferir com usuário
  const [transferredTicketStatus, setTransferredTicketStatus] = useState("open")
  const [loadingTransferredTicketStatus, setLoadingTransferredTicketStatus] = useState(false)

  // Usar carteira de clientes
  const [directTicketsToWallets, setDirectTicketsToWallets] = useState(false)
  const [loadingDirectTicketsToWallets, setLoadingDirectTicketsToWallets] = useState(false)

  // Sigla para inserir no copiar contatos
  const [copyContactPrefix, setCopyContactPrefix] = useState("");
const [loadingCopyContactPrefix, setLoadingCopyContactPrefix] = useState(false);

  // New states for contact copy options
  const [removeCountryCode, setRemoveCountryCode] = useState(false);
  const [loadingRemoveCountryCode, setLoadingRemoveCountryCode] = useState(false);

  const [removeAreaCode, setRemoveAreaCode] = useState(false);
  const [loadingRemoveAreaCode, setLoadingRemoveAreaCode] = useState(false);

  const [removeNinthDigit, setRemoveNinthDigit] = useState(false);
  const [loadingRemoveNinthDigit, setLoadingRemoveNinthDigit] = useState(false);

  //MENSAGENS CUSTOMIZADAS
  const [transferMessage, setTransferMessage] = useState("");
  const [loadingTransferMessage, setLoadingTransferMessage] = useState(false);

  const [greetingAcceptedMessage, setGreetingAcceptedMessage] = useState("");
  const [loadingGreetingAcceptedMessage, setLoadingGreetingAcceptedMessage] = useState(false);

  const [AcceptCallWhatsappMessage, setAcceptCallWhatsappMessage] = useState("");
  const [loadingAcceptCallWhatsappMessage, setLoadingAcceptCallWhatsappMessage] = useState(false);

  const [sendQueuePositionMessage, setSendQueuePositionMessage] = useState("");
  const [loadingSendQueuePositionMessage, setLoadingSendQueuePositionMessage] = useState(false);

  const [showNotificationPending, setShowNotificationPending] = useState(false);
  const [loadingShowNotificationPending, setLoadingShowNotificationPending] = useState(false);

  const { update: updateUserCreation, getAll } = useSettings();

  // const { update: updatedownloadLimit } = useSettings();

  const { update: updateeficlientid } = useSettings();
  const { update: updateeficlientsecret } = useSettings();
  const { update: updateefichavepix } = useSettings();
  const { update: updatempaccesstoken } = useSettings();
  const { update: updatestripeprivatekey } = useSettings();
  const { update: updateasaastoken } = useSettings();
  const { update: updateopenaitoken } = useSettings();

  const { update } = useCompanySettings();

  const isSuper = () => {
    return user.super;
  };


  useEffect(() => {

    if (Array.isArray(oldSettings) && oldSettings.length) {

      const userPar = oldSettings.find((s) => s.key === "userCreation");

      if (userPar) {
        setUserCreation(userPar.value);
      }

      // const downloadLimit = oldSettings.find((s) => s.key === "downloadLimit");

      // if (downloadLimit) {
      //  setdownloadLimit(downloadLimit.value);
      // }

      const copyContactPrefix = oldSettings.find((s) => s.key === 'copyContactPrefix');
      if (copyContactPrefix) {
        setCopyContactPrefix(copyContactPrefix.value);
      }

      const eficlientidType = oldSettings.find((s) => s.key === 'eficlientid');
      if (eficlientidType) {
        setEfiClientidType(eficlientidType.value);
        lastSavedEfiClientid.current = eficlientidType.value;
      }

      const eficlientsecretType = oldSettings.find((s) => s.key === 'eficlientsecret');
      if (eficlientsecretType) {
        setEfiClientsecretType(eficlientsecretType.value);
        lastSavedEfiClientsecret.current = eficlientsecretType.value;
      }

      const efichavepixType = oldSettings.find((s) => s.key === 'efichavepix');
      if (efichavepixType) {
        setEfiChavepixType(efichavepixType.value);
        lastSavedEfiChavepix.current = efichavepixType.value;
      }

      const mpaccesstokenType = oldSettings.find((s) => s.key === 'mpaccesstoken');
      if (mpaccesstokenType) {
        setmpaccesstokenType(mpaccesstokenType.value);
        lastSavedmpaccesstoken.current = mpaccesstokenType.value;
      }

      const asaastokenType = oldSettings.find((s) => s.key === 'asaastoken');
      if (asaastokenType) {
        setasaastokenType(asaastokenType.value);
        lastSavedasaastoken.current = asaastokenType.value;
      }
      
      const stripeprivatekeyType = oldSettings.find((s) => s.key === 'stripeprivatekey');
      if (stripeprivatekeyType) {
        setstripeprivatekeyType(stripeprivatekeyType.value);
        lastSavedstripeprivatekey.current = stripeprivatekeyType.value;
      }
      
      const openaitokenType = oldSettings.find((s) => s.key === 'openaitoken');
      if (openaitokenType) {
        setopenaitokenType(openaitokenType.value);
        lastSavedopenaitoken.current = openaitokenType.value;
      }

    }
  }, [oldSettings])


  useEffect(() => {
    for (const [key, value] of Object.entries(settings)) {
      if (key === "userRating") setUserRating(value);
      if (key === "scheduleType") setScheduleType(value);
      if (key === "chatBotType") setChatBotType(value);
      if (key === "acceptCallWhatsapp") setAcceptCallWhatsapp(value);
      if (key === "userRandom") setUserRandom(value);
      if (key === "sendGreetingMessageOneQueues") setSendGreetingMessageOneQueues(value);
      if (key === "sendSignMessage") setSendSignMessage(value);
      if (key === "sendFarewellWaitingTicket") setSendFarewellWaitingTicket(value);
      if (key === "sendGreetingAccepted") setSendGreetingAccepted(value);
      if (key === "sendQueuePosition") setSendQueuePosition(value);
      if (key === "enableQueuePositionUpdates") setEnableQueuePositionUpdates(value);
      if (key === "queuePositionUpdateInterval") setQueuePositionUpdateInterval(value);
      if (key === "queuePositionUpdateThreshold") setQueuePositionUpdateThreshold(value);
      if (key === "queuePositionSpecialMessage") setQueuePositionSpecialMessage(value);
      if (key === "acceptAudioMessageContact") setAcceptAudioMessageContact(value);
      if (key === "enableLGPD") setEnableLGPD(value);
      if (key === "requiredTag") setRequiredTag(value);
      if (key === "lgpdDeleteMessage") setLGPDDeleteMessage(value)
      if (key === "lgpdHideNumber") setLGPDHideNumber(value);
      if (key === "lgpdConsent") setLGPDConsent(value);
      if (key === "lgpdMessage") setLGPDMessage(value);
      if (key === "sendMsgTransfTicket") setSettingsTransfTicket(value);
      if (key === "lgpdLink") setLGPDLink(value);
      if (key === "DirectTicketsToWallets") setDirectTicketsToWallets(value);
      if (key === "closeTicketOnTransfer") setCloseTicketOnTransfer(value);
      if (key === "transferredTicketStatus") setTransferredTicketStatus(value);
      if (key === "transferMessage") setTransferMessage(value);
      if (key === "greetingAcceptedMessage") setGreetingAcceptedMessage(value);
      if (key === "AcceptCallWhatsappMessage") setAcceptCallWhatsappMessage(value);
      if (key === "sendQueuePositionMessage") setSendQueuePositionMessage(value);
      if (key === "showNotificationPending") setShowNotificationPending(value);
      if (key === "copyContactPrefix") setCopyContactPrefix(value);
      if (key === "removeCountryCode") setRemoveCountryCode(value);
      if (key === "removeAreaCode") setRemoveAreaCode(value);
      if (key === "removeNinthDigit") setRemoveNinthDigit(value);
    }
  }, [settings]);

  async function handleChangeUserCreation(value) {
    setUserCreation(value);
    setLoadingUserCreation(true);
    await updateUserCreation({
      key: "userCreation",
      value,
    });
    setLoadingUserCreation(false);
  }

  // async function handleDownloadLimit(value) {
  //   setdownloadLimit(value);
  //   setLoadingdownloadLimit(true);
  //   await updatedownloadLimit({
  //     key: "downloadLimit",
  //     value,
  //   });
  //   setLoadingdownloadLimit(false);
  // }

  function handleChangeEfiClientid(value) {
    setEfiClientidType(value);
  }

  async function handleSaveEfiClientid(value) {
    if (value === lastSavedEfiClientid.current) return;
    setLoadingEfiClientidType(true);
    await updateeficlientid({
      key: 'eficlientid',
      value,
    });
    lastSavedEfiClientid.current = value;
    showSuccessToast('Operação atualizada com sucesso.');
    setLoadingEfiClientidType(false);
  }

async function handleCopyContactPrefix(value) {
  setCopyContactPrefix(value);
  setLoadingCopyContactPrefix(true);
  await update({
    column: "copyContactPrefix",
    data: value
  });
  setLoadingCopyContactPrefix(false);
}

  function handleChangeEfiClientsecret(value) {
    setEfiClientsecretType(value);
  }

  async function handleSaveEfiClientsecret(value) {
    if (value === lastSavedEfiClientsecret.current) return;
    setLoadingEfiClientsecretType(true);
    await updateeficlientsecret({
      key: 'eficlientsecret',
      value,
    });
    lastSavedEfiClientsecret.current = value;
    showSuccessToast('Operação atualizada com sucesso.');
    setLoadingEfiClientsecretType(false);
  }

  function handleChangeEfiChavepix(value) {
    setEfiChavepixType(value);
  }

  async function handleSaveEfiChavepix(value) {
    if (value === lastSavedEfiChavepix.current) return;
    setLoadingEfiChavepixType(true);
    await updateefichavepix({
      key: 'efichavepix',
      value,
    });
    lastSavedEfiChavepix.current = value;
    showSuccessToast('Operação atualizada com sucesso.');
    setLoadingEfiChavepixType(false);
  }

  function handleChangempaccesstoken(value) {
    setmpaccesstokenType(value);
  }

  async function handleSavempaccesstoken(value) {
    if (value === lastSavedmpaccesstoken.current) return;
    setLoadingmpaccesstokenType(true);
    await updatempaccesstoken({
      key: 'mpaccesstoken',
      value,
    });
    lastSavedmpaccesstoken.current = value;
    showSuccessToast('Operação atualizada com sucesso.');
    setLoadingmpaccesstokenType(false);
  }

  function handleChangestripeprivatekey(value) {
    setstripeprivatekeyType(value);
  }

  async function handleSavestripeprivatekey(value) {
    if (value === lastSavedstripeprivatekey.current) return;
    setLoadingstripeprivatekeyType(true);
    await updatestripeprivatekey({
      key: 'stripeprivatekey',
      value,
    });
    lastSavedstripeprivatekey.current = value;
    showSuccessToast('Operação atualizada com sucesso.');
    setLoadingstripeprivatekeyType(false);
  }

  function handleChangeasaastoken(value) {
    setasaastokenType(value);
  }

  async function handleSaveasaastoken(value) {
    if (value === lastSavedasaastoken.current) return;
    setLoadingasaastokenType(true);
    await updateasaastoken({
      key: 'asaastoken',
      value,
    });
    lastSavedasaastoken.current = value;
    showSuccessToast('Operação atualizada com sucesso.');
    setLoadingasaastokenType(false);
  }

  function handleChangeopenaitoken(value) {
    setopenaitokenType(value);
  }

  async function handleSaveopenaitoken(value) {
    if (value === lastSavedopenaitoken.current) return;
    setLoadingopenaitokenType(true);
    await updateopenaitoken({
      key: 'openaitoken',
      value,
    });
    lastSavedopenaitoken.current = value;
    showSuccessToast('Operação atualizada com sucesso.');
    setLoadingopenaitokenType(false);
  }

  async function handleChangeUserRating(value) {
    setUserRating(value);
    setLoadingUserRating(true);
    await update({
      column: "userRating",
      data: value
    });
    setLoadingUserRating(false);
  }

  async function handleScheduleType(value) {
    setScheduleType(value);
    setLoadingScheduleType(true);
    await update({
      column: "scheduleType",
      data: value
    });
    setLoadingScheduleType(false);
    if (typeof scheduleTypeChanged === "function") {
      scheduleTypeChanged(value);
    }
  }

  async function handleCopyContactPrefix(value) {
    setCopyContactPrefix(value);
    setLoadingCopyContactPrefix(true);
    await update({
      column: "copyContactPrefix",
      data: value
    });
    setLoadingCopyContactPrefix(false);
  }

  async function handleChatBotType(value) {
    setChatBotType(value);
    await update({
      column: "chatBotType",
      data: value
    });
    if (typeof scheduleTypeChanged === "function") {
      setChatBotType(value);
    }
  }

  async function handleLGPDMessage(value) {
    setLGPDMessage(value);
    setLoadingLGPDMessage(true);
    await update({
      column: "lgpdMessage",
      data: value
    });
    setLoadingLGPDMessage(false);
  }

  async function handletransferMessage(value) {
    setTransferMessage(value);
    setLoadingTransferMessage(true);
    await update({
      column: "transferMessage",
      data: value
    });
    setLoadingTransferMessage(false);
  }

  async function handleGreetingAcceptedMessage(value) {
    setGreetingAcceptedMessage(value);
    setLoadingGreetingAcceptedMessage(true);
    await update({
      column: "greetingAcceptedMessage",
      data: value
    });
    setLoadingGreetingAcceptedMessage(false);
  }

  async function handleAcceptCallWhatsappMessage(value) {
    setAcceptCallWhatsappMessage(value);
    setLoadingAcceptCallWhatsappMessage(true);
    await update({
      column: "AcceptCallWhatsappMessage",
      data: value
    });
    setLoadingAcceptCallWhatsappMessage(false);
  }

  async function handlesendQueuePositionMessage(value) {
    setSendQueuePositionMessage(value);
    setLoadingSendQueuePositionMessage(true);
    await update({
      column: "sendQueuePositionMessage",
      data: value
    });
    setLoadingSendQueuePositionMessage(false);
  }

  async function handleShowNotificationPending(value) {
    setShowNotificationPending(value);
    setLoadingShowNotificationPending(true);
    await update({
      column: "showNotificationPending",
      data: value
    });
    setLoadingShowNotificationPending(false);
  }

  async function handleLGPDLink(value) {
    setLGPDLink(value);
    setLoadingLGPDLink(true);
    await update({
      column: "lgpdLink",
      data: value
    });
    setLoadingLGPDLink(false);
  }

  async function handleLGPDDeleteMessage(value) {
    setLGPDDeleteMessage(value);
    setLoadingLGPDDeleteMessage(true);
    await update({
      column: "lgpdDeleteMessage",
      data: value
    });
    setLoadingLGPDDeleteMessage(false);
  }

  async function handleLGPDConsent(value) {
    setLGPDConsent(value);
    setLoadingLGPDConsent(true);
    await update({
      column: "lgpdConsent",
      data: value
    });
    setLoadingLGPDConsent(false);
  }

  async function handleLGPDHideNumber(value) {
    setLGPDHideNumber(value);
    setLoadingLGPDHideNumber(true);
    await update({
      column: "lgpdHideNumber",
      data: value
    });
    setLoadingLGPDHideNumber(false);
  }

  async function handleSendGreetingAccepted(value) {
    setSendGreetingAccepted(value);
    setLoadingSendGreetingAccepted(true);
    await update({
      column: "sendGreetingAccepted",
      data: value
    });
    setLoadingSendGreetingAccepted(false);
  }

  async function handleUserRandom(value) {
    setUserRandom(value);
    setLoadingUserRandom(true);
    await update({
      column: "userRandom",
      data: value
    });
    setLoadingUserRandom(false);
  }

  async function handleSettingsTransfTicket(value) {
    setSettingsTransfTicket(value);
    setLoadingSettingsTransfTicket(true);
    await update({
      column: "sendMsgTransfTicket",
      data: value
    });
    setLoadingSettingsTransfTicket(false);
  }

  async function handleAcceptCallWhatsapp(value) {
    setAcceptCallWhatsapp(value);
    setLoadingAcceptCallWhatsapp(true);
    await update({
      column: "acceptCallWhatsapp",
      data: value
    });
    setLoadingAcceptCallWhatsapp(false);
  }

  async function handleSendSignMessage(value) {
    setSendSignMessage(value);
    setLoadingSendSignMessage(true);
    await update({
      column: "sendSignMessage",
      data: value
    });
    localStorage.setItem("sendSignMessage", value === "enabled" ? true : false); //atualiza localstorage para sessão
    setLoadingSendSignMessage(false);
  }

  async function handleSendGreetingMessageOneQueues(value) {
    setSendGreetingMessageOneQueues(value);
    setLoadingSendGreetingMessageOneQueues(true);
    await update({
      column: "sendGreetingMessageOneQueues",
      data: value
    });
    setLoadingSendGreetingMessageOneQueues(false);
  }

  async function handleSendQueuePosition(value) {
    setSendQueuePosition(value);
    setLoadingSendQueuePosition(true);
    await update({
      column: "sendQueuePosition",
      data: value
    });
    setLoadingSendQueuePosition(false);
  }

  async function handleEnableQueuePositionUpdates(value) {
    setEnableQueuePositionUpdates(value);
    setLoadingEnableQueuePositionUpdates(true);
    await update({
      column: "enableQueuePositionUpdates",
      data: value
    });
    setLoadingEnableQueuePositionUpdates(false);
  }

  async function handleQueuePositionUpdateInterval(value) {
    setQueuePositionUpdateInterval(value);
    setLoadingQueuePositionUpdateInterval(true);
    await update({
      column: "queuePositionUpdateInterval",
      data: value
    });
    setLoadingQueuePositionUpdateInterval(false);
  }

  async function handleQueuePositionUpdateThreshold(value) {
    setQueuePositionUpdateThreshold(value);
    setLoadingQueuePositionUpdateThreshold(true);
    await update({
      column: "queuePositionUpdateThreshold",
      data: value
    });
    setLoadingQueuePositionUpdateThreshold(false);
  }

  async function handleQueuePositionSpecialMessage(value) {
    setQueuePositionSpecialMessage(value);
    setLoadingQueuePositionSpecialMessage(true);
    await update({
      column: "queuePositionSpecialMessage",
      data: value
    });
    setLoadingQueuePositionSpecialMessage(false);
  }

  async function handleSendFarewellWaitingTicket(value) {
    setSendFarewellWaitingTicket(value);
    setLoadingSendFarewellWaitingTicket(true);
    await update({
      column: "sendFarewellWaitingTicket",
      data: value
    });
    setLoadingSendFarewellWaitingTicket(false);
  }

  async function handleAcceptAudioMessageContact(value) {
    setAcceptAudioMessageContact(value);
    setLoadingAcceptAudioMessageContact(true);
    await update({
      column: "acceptAudioMessageContact",
      data: value
    });
    setLoadingAcceptAudioMessageContact(false);
  }

  async function handleEnableLGPD(value) {
    setEnableLGPD(value);
    setLoadingEnableLGPD(true);
    await update({
      column: "enableLGPD",
      data: value
    });
    setLoadingEnableLGPD(false);
  }

  async function handleRequiredTag(value) {
    setRequiredTag(value);
    setLoadingRequiredTag(true);
    await update({
      column: "requiredTag",
      data: value,
    });
    setLoadingRequiredTag(false);
  }

  async function handleCloseTicketOnTransfer(value) {
    setCloseTicketOnTransfer(value);
    setLoadingCloseTicketOnTransfer(true);
    await update({
      column: "closeTicketOnTransfer",
      data: value,
    });
    setLoadingCloseTicketOnTransfer(false);
  }

  async function handleTransferredTicketStatus(value) {
    setTransferredTicketStatus(value);
    setLoadingTransferredTicketStatus(true);
    await update({
      column: "transferredTicketStatus",
      data: value,
    });
    setLoadingTransferredTicketStatus(false);
  }

  async function handleDirectTicketsToWallets(value) {
    setDirectTicketsToWallets(value);
    setLoadingDirectTicketsToWallets(true);
    await update({
      column: "DirectTicketsToWallets",
      data: value,
    });
    setLoadingDirectTicketsToWallets(false);
  }

  // New functions for contact copy options
  async function handleRemoveCountryCode(value) {
    setRemoveCountryCode(value);
    setLoadingRemoveCountryCode(true);
    await update({
      column: "removeCountryCode",
      data: value
    });
    setLoadingRemoveCountryCode(false);
  }

  async function handleRemoveAreaCode(value) {
    setRemoveAreaCode(value);
    setLoadingRemoveAreaCode(true);
    await update({
      column: "removeAreaCode",
      data: value
    });
    setLoadingRemoveAreaCode(false);
  }

  async function handleRemoveNinthDigit(value) {
    setRemoveNinthDigit(value);
    setLoadingRemoveNinthDigit(true);
    await update({
      column: "removeNinthDigit",
      data: value
    });
    setLoadingRemoveNinthDigit(false);
  }

  const theme = useTheme();

  return (
    <Box>
      {/* Seção: Configurações Gerais */}
      <Paper className={classes.sectionCard}>
        <Typography className={classes.sectionTitle}>
          {i18n.t("settings.settings.sections.general") || "Configurações Gerais"}
        </Typography>
        <Typography className={classes.sectionDescription}>
          {i18n.t("settings.settings.sections.generalDescription") || "Configure as opções principais do sistema"}
        </Typography>
        <Grid spacing={3} container>
          {/* CRIAÇÃO DE COMPANY/USERS */}
          {isSuper() ?
            <Grid xs={12} sm={6} md={4} item>
              <FormControl className={classes.formControl}>
              <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
                {i18n.t("settings.settings.options.creationCompanyUser")}
              </Typography>
              <Select
                value={userCreation}
                variant="outlined"
                onChange={async (e) => {
                  handleChangeUserCreation(e.target.value);
                }}
              >
                <MenuItem value={"disabled"}>
                  {i18n.t("settings.settings.options.disabled")}
                </MenuItem>
                <MenuItem value={"enabled"}>
                  {i18n.t("settings.settings.options.enabled")}
                </MenuItem>
              </Select>
              <FormHelperText>
                {loadingUserCreation &&
                  i18n.t("settings.settings.options.updating")}
              </FormHelperText>
            </FormControl>
          </Grid>
          : null}

        {/* LIMITAR DOWNLOAD */}
        {/* {isSuper() ?
          <Grid xs={12} sm={6} md={4} item>
            <FormControl className={classes.formControl}>
              <InputLabel id="downloadLimit-label">
                Limite de Download de Arquivos (MB)
              </InputLabel>
              <Select
                labelId="downloadLimit-label"
                value={downloadLimit}
                size="small"
                variant="outlined"
                onChange={async (e) => {
                  handleDownloadLimit(e.target.value);
                }}
              >
                <MenuItem value={"32"}>32</MenuItem>
                <MenuItem value={"64"}>64</MenuItem>
                <MenuItem value={"128"}>128</MenuItem>
                <MenuItem value={"256"}>256</MenuItem>
                <MenuItem value={"512"}>512</MenuItem>
                <MenuItem value={"1024"}>1024</MenuItem>
                <MenuItem value={"2048"}>2048</MenuItem>
              </Select>
              <FormHelperText>
                {loadingDownloadLimit && "Atualizando..."}
              </FormHelperText>
            </FormControl>
          </Grid>
          : null
        } */}

        {/* AVALIAÇÕES */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.evaluations")}
            </Typography>
            <Select
              value={userRating}
              variant="outlined"
              onChange={async (e) => {
                handleChangeUserRating(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText className={classes.helperText}>
              {loadingUserRating && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* AGENDAMENTO DE EXPEDIENTE */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.officeScheduling")}
            </Typography>
            <Select
              value={scheduleType}
              variant="outlined"
              onChange={async (e) => {
                handleScheduleType(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={"queue"}>{i18n.t("settings.settings.options.queueManagement")}</MenuItem>
              <MenuItem value={"company"}>{i18n.t("settings.settings.options.companyManagement")}</MenuItem>
              <MenuItem value={"connection"}>{i18n.t("settings.settings.options.connectionManagement")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingScheduleType && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ENVIAR SAUDAÇÃO AO ACEITAR O TICKET */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.sendGreetingAccepted")}
            </Typography>
            <Select
              value={SendGreetingAccepted}
              variant="outlined"
              onChange={async (e) => {
                handleSendGreetingAccepted(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText className={classes.helperText}>
              {loadingSendGreetingAccepted && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ESCOLHER OPERADOR ALEATORIO */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.userRandom")}
            </Typography>
            <Select
              value={UserRandom}
              variant="outlined"
              onChange={async (e) => {
                handleUserRandom(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingUserRandom && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ENVIAR MENSAGEM DE TRANSFERENCIA DE SETOR/ATENDENTE */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.sendMsgTransfTicket")}
            </Typography>
            <Select
              value={SettingsTransfTicket}
              variant="outlined"
              onChange={async (e) => {
                handleSettingsTransfTicket(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSettingsTransfTicket && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* TIPO DO BOT */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.chatBotType")}
            </Typography>
            <Select
              value={chatBotType}
              variant="outlined"
              onChange={async (e) => {
                handleChatBotType(e.target.value);
              }}
            >
              <MenuItem value={"text"}>{i18n.t("settings.components.options.textMessageType")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingScheduleType && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* AVISO SOBRE LIGAÇÃO DO WHATSAPP */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.acceptCallWhatsapp")}
            </Typography>
            <Select
              value={AcceptCallWhatsapp}
              variant="outlined"
              onChange={async (e) => {
                handleAcceptCallWhatsapp(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingAcceptCallWhatsapp && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* HABILITAR PARA O ATENDENTE RETIRAR O ASSINATURA */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.sendSignMessage")}
            </Typography>
            <Select
              value={sendSignMessage}
              variant="outlined"
              onChange={async (e) => {
                handleSendSignMessage(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendSignMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ENVIAR SAUDAÇÃO QUANDO HOUVER SOMENTE 1 FILA */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.sendGreetingMessageOneQueues")}
            </Typography>
            <Select
              value={sendGreetingMessageOneQueues}
              variant="outlined"
              onChange={async (e) => {
                handleSendGreetingMessageOneQueues(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendGreetingMessageOneQueues && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ENVIAR MENSAGEM COM A POSIÇÃO DA FILA */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.sendQueuePosition")}
            </Typography>
            <Select
              value={sendQueuePosition}
              variant="outlined"
              onChange={async (e) => {
                handleSendQueuePosition(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendQueuePosition && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* NOTIFICAÇÕES AUTOMÁTICAS DE POSIÇÃO NA FILA */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.components.options.automaticPositionNotifications")}
            </Typography>
            <Select
              value={enableQueuePositionUpdates}
              variant="outlined"
              onChange={async (e) => {
                handleEnableQueuePositionUpdates(e.target.value);
              }}
            >
              <MenuItem value={false}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={true}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingEnableQueuePositionUpdates && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* INTERVALO MÍNIMO ENTRE NOTIFICAÇÕES */}
        {enableQueuePositionUpdates && (
          <Grid xs={12} sm={6} md={4} item>
            <FormControl className={classes.formControl}>
              <TextField
                id="queuePositionUpdateInterval"
                name="queuePositionUpdateInterval"
                margin="dense"
                label={i18n.t("settings.components.options.minimumIntervalMinutes")}
                variant="outlined"
                type="number"
                value={queuePositionUpdateInterval}
                onChange={async (e) => {
                  const value = parseInt(e.target.value) || 1;
                  if (value >= 1) {
                    handleQueuePositionUpdateInterval(value);
                  }
                }}
                InputProps={{ inputProps: { min: 1 } }}
              />
              <FormHelperText>
                {loadingQueuePositionUpdateInterval && i18n.t("settings.settings.options.updating")}
              </FormHelperText>
            </FormControl>
          </Grid>
        )}

        {/* THRESHOLD DE POSIÇÕES */}
        {enableQueuePositionUpdates && (
          <Grid xs={12} sm={6} md={4} item>
            <FormControl className={classes.formControl}>
              <TextField
                id="queuePositionUpdateThreshold"
                name="queuePositionUpdateThreshold"
                margin="dense"
                label={i18n.t("settings.components.options.minimumPositionDifference")}
                variant="outlined"
                type="number"
                value={queuePositionUpdateThreshold}
                onChange={async (e) => {
                  const value = parseInt(e.target.value) || 1;
                  if (value >= 1) {
                    handleQueuePositionUpdateThreshold(value);
                  }
                }}
                InputProps={{ inputProps: { min: 1 } }}
              />
              <FormHelperText>
                {loadingQueuePositionUpdateThreshold && i18n.t("settings.settings.options.updating")}
              </FormHelperText>
            </FormControl>
          </Grid>
        )}

        {/* MENSAGEM ESPECIAL PARA POSIÇÃO 1 */}
        {enableQueuePositionUpdates && (
          <Grid xs={12} sm={12} md={12} item>
            <FormControl className={classes.formControl}>
                <MaskInput
                  id="queuePositionSpecialMessage"
                  name="queuePositionSpecialMessage"
                  margin="dense"
                  label={i18n.t("settings.components.options.specialPositionMessage")}
                  variant="outlined"
                  multiline
                  rows={2}
                  value={queuePositionSpecialMessage}
                  placeholder={i18n.t("settings.components.options.specialPositionPlaceholder")}
                  onChange={async (e) => {
                    handleQueuePositionSpecialMessage(e.target.value);
                  }}
                  helperText={loadingQueuePositionSpecialMessage ? i18n.t("settings.settings.options.updating") : i18n.t("settings.components.options.queuePositionHelper")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
            </FormControl>
          </Grid>
        )}

        {/* ENVIAR MENSAGEM DE DESPEDIDA NO AGUARDANDO */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.sendFarewellWaitingTicket")}
            </Typography>
            <Select
              value={sendFarewellWaitingTicket}
              variant="outlined"
              onChange={async (e) => {
                handleSendFarewellWaitingTicket(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendFarewellWaitingTicket && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.acceptAudioMessageContact")}
            </Typography>
            <Select
              value={acceptAudioMessageContact}
              variant="outlined"
              onChange={async (e) => {
                handleAcceptAudioMessageContact(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingAcceptAudioMessageContact && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.enableLGPD")}
            </Typography>
            <Select
              value={enableLGPD}
              variant="outlined"
              onChange={async (e) => {
                handleEnableLGPD(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.settings.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingEnableLGPD && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.requiredTag")}
            </Typography>
            <Select
              value={requiredTag}
              variant="outlined"
              onChange={async (e) => {
                handleRequiredTag(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.settings.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingRequiredTag && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.closeTicketOnTransfer")}
            </Typography>
            <Select
              value={closeTicketOnTransfer}
              variant="outlined"
              onChange={async (e) => {
                handleCloseTicketOnTransfer(e.target.value);
              }}
            >
              <MenuItem value={false}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={true}>{i18n.t("settings.settings.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingCloseTicketOnTransfer && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.transferredTicketStatus")}
            </Typography>
            <Select
              value={transferredTicketStatus}
              variant="outlined"
              onChange={async (e) => {
                handleTransferredTicketStatus(e.target.value);
              }}
            >
              <MenuItem value={"open"}>{i18n.t("settings.settings.options.open")}</MenuItem>
              <MenuItem value={"pending"}>{i18n.t("settings.settings.options.pending")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingTransferredTicketStatus && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.showNotificationPending")}
            </Typography>
            <Select
              value={showNotificationPending}
              variant="outlined"
              onChange={async (e) => {
                handleShowNotificationPending(e.target.value);
              }}
            >
              <MenuItem value={false}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={true}>{i18n.t("settings.settings.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingShowNotificationPending && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.formControl} fullWidth>
            <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
              {i18n.t("settings.settings.options.DirectTicketsToWallets")}
            </Typography>
            <Select
              value={directTicketsToWallets}
              variant="outlined"
              onChange={async (e) => {
                handleDirectTicketsToWallets(e.target.value);
              }}
            >
              <MenuItem value={false}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={true}>{i18n.t("settings.settings.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingDirectTicketsToWallets && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
        </Grid>
      </Paper>

      {/* Seção: Configuração de Sigla para Cópia de Contatos */}
      <Paper className={classes.sectionCard}>
        <Typography className={classes.sectionTitle}>
          {i18n.t("settings.settings.sections.copyContact") || "Configuração de Sigla para Cópia de Contatos"}
        </Typography>
        <Typography className={classes.sectionDescription}>
          {i18n.t("settings.settings.sections.copyContactDescription") || "Configure como os números de telefone são formatados ao copiar contatos"}
        </Typography>
        <Grid spacing={3} container>
                  <Tabs
            indicatorColor='primary'
            textColor='primary'
            scrollButtons='on'
            variant='scrollable'
            className={classes.tab}
            style={{
              marginBottom: 20,
              marginTop: 20,
            }}
          >
            <Tab label={i18n.t("settings.components.options.copyContactTab")} />
          </Tabs>
        <Grid xs={12} sm={6} md={6} item>
          <FormControl className={classes.formControl}>
            <TextField
              id="copyContactPrefix"
              name="copyContactPrefix"
              margin="dense"
              label={i18n.t("settings.settings.options.copyContactPrefix")}
              variant="outlined"
              value={copyContactPrefix}
              placeholder={i18n.t("settings.settings.options.copyContactPrefixPlaceholder")}
              onChange={async (e) => {
                handleCopyContactPrefix(e.target.value);
              }}
                InputLabelProps={{
    shrink: true,
  }}
            />
            <FormHelperText>
              {loadingCopyContactPrefix && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
        
        {/* New checkboxes for contact copy options */}
        <Grid xs={12} sm={6} md={6} item>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={removeCountryCode}
                    onChange={async (e) => {
                      handleRemoveCountryCode(e.target.checked);
                    }}
                    name="removeCountryCode"
                    color="primary"
                  />
                }
                label={i18n.t("settings.components.options.removeCountryCode")}
              />
              {loadingRemoveCountryCode && (
                <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
              )}
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={removeAreaCode}
                    onChange={async (e) => {
                      handleRemoveAreaCode(e.target.checked);
                    }}
                    name="removeAreaCode"
                    color="primary"
                  />
                }
                label={i18n.t("settings.components.options.removeAreaCode")}
              />
              {loadingRemoveAreaCode && (
                <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
              )}
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={removeNinthDigit}
                    onChange={async (e) => {
                      handleRemoveNinthDigit(e.target.checked);
                    }}
                    name="removeNinthDigit"
                    color="primary"
                  />
                }
                label={i18n.t("settings.components.options.removeNinthDigit")}
              />
              {loadingRemoveNinthDigit && (
                <FormHelperText>{i18n.t("settings.settings.options.updating")}</FormHelperText>
              )}
            </Grid>
          </Grid>
        </Grid>
        </Grid>
      </Paper>

      {/* Seção: LGPD */}
      {enableLGPD === "enabled" && (
        <Paper className={classes.sectionCard}>
          <Typography className={classes.sectionTitle}>
            {i18n.t("settings.settings.sections.lgpd") || "LGPD"}
          </Typography>
          <Typography className={classes.sectionDescription}>
            {i18n.t("settings.settings.sections.lgpdDescription") || "Configurações de privacidade e proteção de dados"}
          </Typography>
          <Grid spacing={3} container>
            <Tabs
              value={0}
              indicatorColor="primary"
              textColor="primary"
              scrollButtons="on"
              variant="scrollable"
              className={classes.tab}
            >
              <Tab

                label={i18n.t("settings.settings.LGPD.title")} />

            </Tabs>
          </Grid>
          <Grid spacing={1} container>
            <Grid xs={12} sm={6} md={12} item>
              <FormControl className={classes.formControl}>
                <MaskInput
                  id="lgpdMessage"
                  name="lgpdMessage"
                  margin="dense"
                  multiline
                  rows={3}
                  label={i18n.t("settings.settings.LGPD.welcome")}
                  variant="outlined"
                  value={lgpdMessage}
                  onChange={async (e) => {
                    handleLGPDMessage(e.target.value);
                  }}
                  helperText={loadinglgpdMessage ? i18n.t("settings.settings.options.updating") : i18n.t("settings.components.options.nameMsHelper")}
                />
              </FormControl>
            </Grid>
            <Grid xs={12} sm={6} md={12} item>
              <FormControl className={classes.formControl}>
                <TextField
                  id="lgpdLink"
                  name="lgpdLink"
                  margin="dense"
                  label={i18n.t("settings.settings.LGPD.linkLGPD")}
                  variant="outlined"
                  value={lgpdLink}
                  onChange={async (e) => {
                    handleLGPDLink(e.target.value);
                  }}
                >
                </TextField>
                <FormHelperText>
                  {loadingLGPDLink && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
            </Grid>
            {/* LGPD Manter ou nao mensagem deletada pelo contato */}
            <Grid xs={12} sm={6} md={4} item>
              <FormControl className={classes.formControl}>
                <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
                  {i18n.t("settings.settings.LGPD.obfuscateMessageDelete")}
                </Typography>
                <Select
                  value={lgpdDeleteMessage}
                  variant="outlined"
                  onChange={async (e) => {
                    handleLGPDDeleteMessage(e.target.value);
                  }}
                >
                  <MenuItem value={"disabled"}>{i18n.t("settings.settings.LGPD.disabled")}</MenuItem>
                  <MenuItem value={"enabled"}>{i18n.t("settings.settings.LGPD.enabled")}</MenuItem>
                </Select>
                <FormHelperText>
                  {loadingLGPDDeleteMessage && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
            </Grid>
            {/* LGPD Sempre solicitar confirmaçao / conscentimento dos dados */}
            <Grid xs={12} sm={6} md={4} item>
              <FormControl className={classes.formControl}>
                <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
                  {i18n.t("settings.settings.LGPD.alwaysConsent")}
                </Typography>
                <Select
                  value={lgpdConsent}
                  variant="outlined"
                  onChange={async (e) => {
                    handleLGPDConsent(e.target.value);
                  }}
                >
                  <MenuItem value={"disabled"}>{i18n.t("settings.settings.LGPD.disabled")}</MenuItem>
                  <MenuItem value={"enabled"}>{i18n.t("settings.settings.LGPD.enabled")}</MenuItem>
                </Select>
                <FormHelperText>
                  {loadingLGPDConsent && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
            </Grid>
            {/* LGPD Ofuscar número telefone para usuários */}
            <Grid xs={12} sm={6} md={4} item>
              <FormControl className={classes.formControl}>
                <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 500, color: theme.palette.text.secondary }}>
                  {i18n.t("settings.settings.LGPD.obfuscatePhoneUser")}
                </Typography>
                <Select
                  value={lgpdHideNumber}
                  variant="outlined"
                  onChange={async (e) => {
                    handleLGPDHideNumber(e.target.value);
                  }}
                >
                  <MenuItem value={"disabled"}>{i18n.t("settings.settings.LGPD.disabled")}</MenuItem>
                  <MenuItem value={"enabled"}>{i18n.t("settings.settings.LGPD.enabled")}</MenuItem>
                </Select>
                <FormHelperText>
                  {loadingLGPDHideNumber && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>
      )}

      {/* Seção: Pagamentos */}
      {isSuper() && (
        <Paper className={classes.sectionCard}>
          <Typography className={classes.sectionTitle}>
            {i18n.t("settings.settings.sections.payments") || "Métodos de Pagamento"}
          </Typography>
          <Typography className={classes.sectionDescription}>
            {i18n.t("settings.settings.sections.paymentsDescription") || "Configure as integrações de pagamento"}
          </Typography>
          <Grid spacing={3} container>
        <Grid xs={12} sm={6} md={6} item>
          {isSuper() ?
            <FormControl className={classes.formControl}>
              <TextField
                id='eficlientid'
                name='eficlientid'
                margin='dense'
                label='Client ID'
                variant='outlined'
                value={eficlientidType}
                onChange={(e) => {
                  handleChangeEfiClientid(e.target.value);
                }}
                onBlur={(e) => {
                  handleSaveEfiClientid(e.target.value);
                }}
              ></TextField>
              <FormHelperText>
                {loadingEfiClientidType && i18n.t("settings.settings.options.updating")}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={6} md={6} item>
          {isSuper() ?
            <FormControl className={classes.formControl}>
              <TextField
                id='eficlientsecret'
                name='eficlientsecret'
                margin='dense'
                label='Client Secret'
                variant='outlined'
                value={eficlientsecretType}
                onChange={(e) => {
                  handleChangeEfiClientsecret(e.target.value);
                }}
                onBlur={(e) => {
                  handleSaveEfiClientsecret(e.target.value);
                }}
              ></TextField>
              <FormHelperText>
                {loadingEfiClientsecretType && i18n.t("settings.settings.options.updating")}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={12} md={12} item>
          {isSuper() ?
            <FormControl className={classes.formControl}>
              <TextField
                id='efichavepix'
                name='efichavepix'
                margin='dense'
                label='Chave PIX'
                variant='outlined'
                value={efichavepixType}
                onChange={(e) => {
                  handleChangeEfiChavepix(e.target.value);
                }}
                onBlur={(e) => {
                  handleSaveEfiChavepix(e.target.value);
                }}
              ></TextField>
              <FormHelperText>
                {loadingEfiChavepixType && i18n.t("settings.settings.options.updating")}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={12} md={12} item>
          {isSuper() ?
            <FormControl className={classes.formControl}>
              <TextField
                id='mpaccesstoken'
                name='mpaccesstoken'
                margin='dense'
                label='Mercado Pago - Access Token'
                variant='outlined'
                value={mpaccesstokenType}
                onChange={(e) => {
                  handleChangempaccesstoken(e.target.value);
                }}
                onBlur={(e) => {
                  handleSavempaccesstoken(e.target.value);
                }}
              ></TextField>
              <FormHelperText className={classes.helperText}>
                {loadingmpaccesstokenType && i18n.t("settings.settings.options.updating")}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={12} md={12} item>
          {isSuper() ?
            <FormControl className={classes.formControl}>
              <TextField
                id='stripeprivatekey'
                name='stripeprivatekey'
                margin='dense'
                label='Stripe - Private Key'
                variant='outlined'
                value={stripeprivatekeyType}
                onChange={(e) => {
                  handleChangestripeprivatekey(e.target.value);
                }}
                onBlur={(e) => {
                  handleSavestripeprivatekey(e.target.value);
                }}
              ></TextField>
              <FormHelperText className={classes.helperText}>
                {loadingstripeprivatekeyType && i18n.t("settings.settings.options.updating")}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={12} md={12} item>
          {isSuper() ?
            <FormControl className={classes.formControl}>
              <TextField
                id='asaastoken'
                name='asaastoken'
                margin='dense'
                label='ASAAS - Token'
                variant='outlined'
                value={asaastokenType}
                onChange={(e) => {
                  handleChangeasaastoken(e.target.value);
                }}
                onBlur={(e) => {
                  handleSaveasaastoken(e.target.value);
                }}
              ></TextField>
              <FormHelperText className={classes.helperText}>
                {loadingasaastokenType && i18n.t("settings.settings.options.updating")}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
          </Grid>
        </Paper>
      )}

      {/* Seção: Transcrição de Áudio */}
      {isSuper() && (
        <Paper className={classes.sectionCard}>
          <Typography className={classes.sectionTitle}>
            {i18n.t("settings.settings.sections.transcription") || "Transcrição de Áudio"}
          </Typography>
          <Typography className={classes.sectionDescription}>
            {i18n.t("settings.settings.sections.transcriptionDescription") || "Configure a API de transcrição de áudio"}
          </Typography>
          <Grid spacing={3} container>
            <Grid xs={12} sm={12} md={12} item>
              <FormControl className={classes.formControl}>
                <TextField
                  id='openaitoken'
                  name='openaitoken'
                  margin='dense'
                  label='OpenAI API Key'
                  variant='outlined'
                  value={openaitokenType}
                  onChange={(e) => {
                    handleChangeopenaitoken(e.target.value);
                  }}
                  onBlur={(e) => {
                    handleSaveopenaitoken(e.target.value);
                  }}
                ></TextField>
                <FormHelperText className={classes.helperText}>
                  {loadingopenaitokenType && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>
      )}

      {/* Seção: Mensagens Customizadas */}
      <Paper className={classes.sectionCard}>
        <Typography className={classes.sectionTitle}>
          {i18n.t("settings.settings.sections.messages") || "Mensagens Customizadas"}
        </Typography>
        <Typography className={classes.sectionDescription}>
          {i18n.t("settings.settings.sections.messagesDescription") || "Personalize as mensagens enviadas automaticamente pelo sistema"}
        </Typography>
        <Grid spacing={3} container>
          <Grid xs={12} sm={6} md={6} item>
            <FormControl className={classes.formControl}>
              <MaskInput
                id="transferMessage"
                name="transferMessage"
                margin="dense"
                multiline
                rows={3}
                label={i18n.t("settings.settings.customMessages.transferMessage")}
                variant="outlined"
                value={transferMessage}
                required={SettingsTransfTicket === "enabled"}
                onChange={async (e) => {
                  handletransferMessage(e.target.value);
                }}
                helperText={loadingTransferMessage ? i18n.t("settings.settings.options.updating") : i18n.t("settings.components.options.nameQueueMsHelper")}
              />
            </FormControl>
          </Grid>

          <Grid xs={12} sm={6} md={6} item>
            <FormControl className={classes.formControl}>
              <MaskInput
                id="greetingAcceptedMessage"
                name="greetingAcceptedMessage"
                margin="dense"
                multiline
                rows={3}
                label={i18n.t("settings.settings.customMessages.greetingAcceptedMessage")}
                variant="outlined"
                value={greetingAcceptedMessage}
                required={SendGreetingAccepted === "enabled"}
                onChange={async (e) => {
                  handleGreetingAcceptedMessage(e.target.value);
                }}
                helperText={loadingGreetingAcceptedMessage ? i18n.t("settings.settings.options.updating") : i18n.t("settings.components.options.nameUserMsHelper")}
              />
            </FormControl>
          </Grid>

          <Grid xs={12} sm={6} md={6} item>
            <FormControl className={classes.formControl}>
              <MaskInput
                id="AcceptCallWhatsappMessage"
                name="AcceptCallWhatsappMessage"
                margin="dense"
                multiline
                rows={3}
                label={i18n.t("settings.settings.customMessages.AcceptCallWhatsappMessage")}
                variant="outlined"
                required={AcceptCallWhatsapp === "disabled"}
                value={AcceptCallWhatsappMessage}
                onChange={async (e) => {
                  handleAcceptCallWhatsappMessage(e.target.value);
                }}
                helperText={loadingAcceptCallWhatsappMessage ? i18n.t("settings.settings.options.updating") : i18n.t("settings.components.options.nameMsHelper")}
              />
            </FormControl>
          </Grid>

          <Grid xs={12} sm={6} md={6} item>
            <FormControl className={classes.formControl}>
              <MaskInput
                id="sendQueuePositionMessage"
                name="sendQueuePositionMessage"
                margin="dense"
                multiline
                required={sendQueuePosition === "enabled"}
                rows={3}
                label={i18n.t("settings.settings.customMessages.sendQueuePositionMessage")}
                variant="outlined"
                value={sendQueuePositionMessage}
                onChange={async (e) => {
                  handlesendQueuePositionMessage(e.target.value);
                }}
                helperText={loadingSendQueuePositionMessage ? i18n.t("settings.settings.options.updating") : i18n.t("settings.components.options.queuePositionHelper")}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
